import { render, staticRenderFns } from "./EmailDocumentEditor.vue?vue&type=template&id=78e63058&scoped=true"
import script from "./EmailDocumentEditor.vue?vue&type=script&lang=js"
export * from "./EmailDocumentEditor.vue?vue&type=script&lang=js"
import style0 from "./EmailDocumentEditor.vue?vue&type=style&index=0&id=78e63058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e63058",
  null
  
)

export default component.exports